module.exports = __webpack_public_path__ + "static/img/gpt44.ee9737d9.png";